import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'
import interceptorSetup from '@/helpers/httpInterceptors'
import configureEventSources from '@/helpers/eventsource'
import './helpers/filters'
import './helpers/fontAwesome'
import './helpers/materialIcons'

import AppButton from '@/components/ui/AppButton'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'

interceptorSetup()
configureEventSources()

Vue.component('AppButton', AppButton)

Vue.use(Notifications, { velocity })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: function () {
    this.$store.dispatch('authentication/setUserFromLocalstorage')
  },
  render: h => h(App)
}).$mount('#app')
